import { FC } from 'react';

import { PageWrapper } from '../../components';
import { PlatformCountsSection } from './components';

export const DashboardView: FC = () => (
  <PageWrapper>
    <PlatformCountsSection />
  </PageWrapper>
);
